import type React from "react";
import { UnauthorizedState } from "../components/feedback/UnauthorizedState";
import { i18n } from "@frontend/i18n";
import { useMagicLinkController } from "../controllers/useMagicLinkController";

export function MagicLinkPage(): React.JSX.Element {
  const { state } = useMagicLinkController();

  if (state.errorMessage !== null) {
    return (
      <div
        className="flex min-h-screen items-center justify-center"
        data-testid="magic-link-error"
      >
        <UnauthorizedState message={state.errorMessage} />
      </div>
    );
  }

  return (
    <div
      className="flex min-h-screen items-center justify-center"
      data-testid={`magic-link-${state.isSuccess ? "success" : "processing"}`}
    >
      <div className="flex flex-col items-center gap-3">
        <div
          className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-primary"
          role="status"
          aria-label="Processing"
        />
        <span className="text-sm text-muted-foreground">
          {i18n.t("magicLink.title.processing")}
        </span>
      </div>
    </div>
  );
}
